/**
 *
 * Isolated scope for each mega menu
 */
export const C__MenuMegaMain = () => ({
    pageLoaded: false,
    currentMega: 0,
    currentChild: 0,
    pageReady() {
        this.pageLoaded = true;
    },
    megaOpen(id) {
        // if (this.currentMega == id) return false;
        // console.group('open');
        // console.log('current before ', this.currentMega);
        // this.currentMega = id;
        // console.log('current after', id);
        // console.groupEnd();
    },
    megaClose(id) {
        // if (this.currentMega == id) return false;
        // console.log('closing', this.currentMega);
        // console.group('close');
        // console.warn('asking to close ', id);
        // this.currentMega = id;
        // console.warn('current after', this.currentMega);
        // console.groupEnd();
        // this.currentMega = 0;
    },
    showGrandChildren(id) {
        this.currentChild = id;
    }
});
